export const FORM_FIELD_CAMPUS = 'campus';
export const FORM_FIELD_REFER_TO_CHAPTER = 'refer to chapter';
export const FORM_FIELD_TYPE_OF_ORGANIZATION =
  'what type of organizations are you interested in?';
export const FORM_FIELD_ORGANIZATION_FOCUSES =
  'what organization focuses are you interested in?';
